<template>
  <div class="main-content">
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <h2 class="mb-2">{{ $t("Dashboard") }}</h2>
                <p class="text-muted mb-md-0">
                  {{
                    `Welcome ${profile.name} ${
                      company_name != "" ? "From " + company_name : ""
                    }`
                  }}
                </p>
              </div>
              <div class="col-12 col-md-auto d-none">
                <button
                  class="btn btn-primary lift"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal">
                  <span class="fe fe-folder-plus"></span>
                  Report
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CARDS -->
    <div class="container-fluid">
      <div class="card">
        <div class="card-body mt-3 mb-3">
          <div class="row mb-4">
            <div class="col-lg-4">
              <div class="row">
                <div class="col-5">
                  <p class="small">
                    <strong>Name</strong>
                  </p>
                </div>
                <div class="col">
                  <p class="small">{{ profile.name }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  <p class="small">
                    <strong>Department</strong>
                  </p>
                </div>
                <div class="col">
                  <p
                    class="small"
                    v-if="
                      profile.department != null ||
                      profile.department != undefined
                    ">
                    {{ profile.department }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  <p class="small">
                    <strong>Position</strong>
                  </p>
                </div>
                <div class="col">
                  <p
                    class="small"
                    v-if="
                      profile.position_title != null ||
                      profile.position_title != undefined
                    ">
                    {{ profile.position_title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <vue-good-table
            :line-numbers="true"
            :columns="column"
            :rows="profile.resource_access"
            :sort-options="{
              enabled: false
            }"
            :total-rows="10"
            :pagination-options="{
              enabled: false,
              mode: 'pages',
              position: 'bottom',
              perPage: 10,
              perPageDropdown: [10, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page',
              allLabel: 'All'
            }"
            style-class="vgt-table border-0 table">
            <!-- Loading -->
            <div slot="emptystate" class="text-center font-size-14">
              No data available
            </div>
            <!-- Custom Rows -->
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'role'">
                {{ props.row.role.join(", ") }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <!-- Active Users Card -->
    <div class="container-fluid">
      <div class="card">
        <div class="card-body mt-3 mb-3">
          <div class="row mb-4">
            <div class="col-lg-4">
              <div class="row">
                <div class="col-4">
                  <p class="small">
                    <strong>Active Users</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <vue-good-table
            :line-numbers="true"
            :columns="columnReport"
            :rows="listActive.data"
            :sort-options="{
              enabled: true
            }"
            :total-rows="10"
            :pagination-options="{
              enabled: false,
              mode: 'pages',
              position: 'bottom',
              perPage: 10,
              perPageDropdown: [10, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page',
              allLabel: 'All'
            }"
            style-class="vgt-table border-0 table">
            <!-- Loading -->
            <div slot="emptystate" class="text-center font-size-14">
              No data available
            </div>
            <!-- Custom Rows -->
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'role'">
                {{ props.row.role.join(", ") }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      direct: "All",
      company_id: "",
      fullname: "",
      departement: "",
      position: "",
      company_name: "",
      posts: [],
      column: [
        {
          label: "Application",
          field: "application_name",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Role",
          field: "role",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Assign By",
          field: "assignBy",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        }
      ],
      columnReport: [
        {
          label: "Application",
          field: "clientId",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Active Users",
          field: "active",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        }
      ]
    };
  },
  computed: {
    profile() {
      return this.$store.getters["profile/profileData"]
        ? this.$store.getters["profile/profileData"]
        : [];
    },
    listActive() {
      return this.$store.getters["role_template/listActive"]
        ? this.$store.getters["role_template/listActive"]
        : [];
    }
  },
  mounted() {
    setTimeout(() => {
      this.getActive();
      this.getProfile();
    }, 1000);
    // this.filterMenu();
  },
  methods: {
    directTabs(data) {
      if (data === "All") {
        this.direct = "All";
      } else if (data === "Closed") {
        this.direct = "Closed";
      } else if (data === "OnGoing") {
        this.direct = "OnGoing";
      } else if (data === "EarlyTermination") {
        this.direct = "EarlyTermination";
      }
    },
    getProfile() {
      this.$store.dispatch("profile/getProfile");
    },

    getActive() {
      this.$store.dispatch("role_template/GET_LIST_ACTIVE");
    }

    // filterMenu() {
    //   let roles = localStorage.getItem("roles");
    //   let dat = roles.split(",");
    //   if (dat.length === 1 && dat[0] === "basic") {
    //     this.renderActiveCard(true);
    //   } else if (dat.length === 2 && dat[0] === "admin") {
    //     this.renderActiveCard(true);
    //   } else {
    //     this.renderActiveCard(false);
    //   }
    // },
    // renderActiveCard(show) {
    //   this.showActiveCard = show;
    // }
  }
};
</script>
